<template>
    <settings-wrapper title="Space settings" :section="settingsSectionLabel">
        <student-quotas v-if="showStudentQuotasPanel" />
        <file-quotas v-if="showFileQuotasPanel" :space-id="activeSpaceId" :space-type="currentSpaceType" />
    </settings-wrapper>
</template>

<script>
import { mapState } from 'vuex'
import { isAdminRole } from '@/utils'
import { enumsData } from '@/mixins/enums'
import SettingsWrapper from '@/components/SettingsWrapper.vue'

const FileQuotas = () => import('../components/FileQuotas.vue')
const StudentQuotas = () => import('../components/StudentQuotas.vue')

export default {
    name: 'SpaceConfigurationQuotas',
    mixins: [enumsData],
    components: {
        FileQuotas,
        StudentQuotas,
        SettingsWrapper
    },
    async created() {
        if (this.activeOrgId && !this.spacesWithPrimarySnapshots.length) {
            await this.$store.dispatch('orgStore/fetchOrgSpaces', this.activeOrgId)
        }
    },
    computed: {
        ...mapState('orgStore', ['spacesWithPrimarySnapshots']),
        activeOrgId() {
            return this.$route.params.oid
        },
        activeSpaceId() {
            return this.$route.params.sid
        },
        activeSpaceData() {
            if (!this.activeSpaceId) {
                return null
            }
            return this.spacesWithPrimarySnapshots.find(space => space.sid.toString() === this.activeSpaceId.toString()) || null
        },
        isSpaceAdmin() {
            return isAdminRole(this.activeSpaceData?.space_role)
        },
        currentSpaceType() {
            return this.activeSpaceData?.space_type || null
        },
        isCreditQuotasRoute() {
            return this.$route.name === 'config-space-credit-quotas'
        },
        showStudentQuotasOnly() {
            const requestedSection = this.$route.query.section || this.$route.query.tab
            return this.isCreditQuotasRoute || requestedSection === 'student-quotas'
        },
        showStudentQuotasPanel() {
            return this.showStudentQuotasOnly
        },
        showFileQuotasPanel() {
            return !this.showStudentQuotasOnly
        },
        settingsSectionLabel() {
            return this.showStudentQuotasOnly ? 'Credit quotas' : 'File quotas and usage'
        }
    },
    watch: {
        spacesWithPrimarySnapshots: {
            immediate: true,
            handler(spaces) {
                if (!this.$route.params.sid && Array.isArray(spaces) && spaces.length) {
                    this.$router.replace({
                        name: this.$route.name,
                        params: {
                            ...this.$route.params,
                            sid: spaces[0].sid
                        },
                        query: { ...this.$route.query }
                    })
                }
            }
        },
        activeSpaceData: {
            immediate: true,
            handler() {
                if (!this.activeSpaceId || !this.activeSpaceData) {
                    return
                }
                if (this.isSpaceAdmin === false) {
                    this.$router.replace({
                        name: 'config-space-general',
                        params: {
                            oid: this.activeOrgId,
                            sid: this.activeSpaceId
                        },
                        query: { ...this.$route.query }
                    })
                }
            }
        }
    }
}
</script>
